<div class="d-flex align-items-center justify-content-center marketing-badge">
  <span
    i18n="ProductCard|Product Card Marketing Label@@productCardMarketingLabel"
    >Marketing</span
  >
</div>
